import type { ProjectApi } from 'api-typings/projects/projects';
import type { SearchActiveLoad } from './search-active-loads.model';
import {
  transformDisplayedLocation,
  transformProjectLocalDetails,
} from '../project-view-projects/project-view-projects.transformers';
import { transformProject } from '../projects/projects.transformers';
import type { WebsocketProjectSearchActiveEvent } from '../search-active-projects';
import { transformWebsocketSearchActiveProject } from '../search-active-projects/search-active-projects.transformers';
import { transformSkill } from '../skills/skills.transformers';
import { transformLocation } from '../users/users-location.transformers';

export function transformSearchActiveLoad(
  project: ProjectApi,
): SearchActiveLoad {
  if (!project.location || !project.time_submitted) {
    throw new ReferenceError(`Missing a required project entry field.`);
  }

  const localDetails = project.local_details
    ? transformProjectLocalDetails(project.local_details)
    : undefined;
  const location = project.location
    ? transformLocation(project.location)
    : undefined;

  return {
    ...transformProject(project),
    displayStartLocation: transformDisplayedLocation(
      project.true_location || project.location,
    ),
    localDetails,
    location,
    skillIds: project.jobs?.map(job => job.id) ?? [],
    skills: project.jobs?.map(transformSkill) ?? [],
    pickupDateInMs: localDetails?.workStartDate,
    timeUpdated: project.time_updated
      ? project.time_updated * 1000
      : project.time_submitted * 1000,
  };
}

export function transformWebsocketSearchActiveLoad(
  event: WebsocketProjectSearchActiveEvent,
): SearchActiveLoad {
  return {
    ...transformWebsocketSearchActiveProject(event),
    timeUpdated: event.data.time_submitted * 1000,
  };
}
